import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText
} from '@jdreact/jdreact-core-lib';

import { pt, px } from '../../common/utils';

export default class Tag extends PureComponent {
    render() {
        // let  { cinemaTag, contentStyle }  = this.props;
        const { cinemaTag, contentStyle } = this.props;

        if (!cinemaTag) {
            return null;
        }

        return (
            (cinemaTag.glassesinfo ||
            cinemaTag.parkingfee ||
            cinemaTag.wifi) && <View style={ [st.promo, contentStyle] }>
                {
                    Object.keys(cinemaTag).map((item, index) => {
                        const txt = {
                            glassesinfo: '3D眼镜',
                            parkingfee: '停车场',
                            wifi: 'Wifi'
                        };

                        return (
                            cinemaTag[item] && <View style={ st.view } key={ index }><JDText style={ st.promoTxt }>{txt[item]}</JDText></View>
                        );
                    })
                }
            </View>
        );
    }
}

const st = StyleSheet.create({
    promo: {
        marginTop: pt(10),
        paddingLeft: pt(15),
        paddingTop: 0,
        flexDirection: 'row'
    },
    view: {
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: px(1),
        borderColor: '#71A0FF',
        marginRight: pt(5),
        borderRadius: pt(2),
        height: pt(16)
    },
    promoTxt: {
        color: '#71A0FF',
        fontSize: pt(10),
        paddingLeft: pt(2),
        paddingRight: pt(2)
    }
})
;
